function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import FullscreenSlider from './fullscreenSlider.js';
import FullscreenDesktopNavbar from './fullscreenDesktopNavbar.js';
import BottomLink from './bottomLink.js';
import { Consts } from '@wix/photography-client-lib';
import { fixedStyles } from './proGallerySliderFixedStyles';
import ProGallerySlider from './ProGallerySlider';

var DesktopFullscreen = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DesktopFullscreen, _React$Component);

  function DesktopFullscreen(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.isExpandedView = true;
    _this.isTouchDeviceZoom = false;
    return _this;
  }

  var _proto = DesktopFullscreen.prototype;

  _proto.getSlider = function getSlider() {
    var shouldUseProGallerySlider = this.props.shouldUseProGallerySlider;

    var props = _objectSpread(_objectSpread({}, this.props), {}, {
      isExpandedView: this.isExpandedView,
      isTouchDeviceZoom: this.isTouchDeviceZoom
    });

    if (shouldUseProGallerySlider) {
      return this.getProGallerySlider();
    }

    return /*#__PURE__*/React.createElement(FullscreenSlider, props);
  };

  _proto.getDesktopNavbar = function getDesktopNavbar() {
    return /*#__PURE__*/React.createElement(FullscreenDesktopNavbar, _extends({}, this.props, {
      showInfo: false
    }));
  };

  _proto.getProGallerySlider = function getProGallerySlider() {
    var _this$props = this.props,
        items = _this$props.items,
        resizeMediaUrl = _this$props.resizeMediaUrl,
        totalItems = _this$props.totalItems,
        current = _this$props.current,
        actions = _this$props.actions;
    var props = {
      container: this.getProGalleryContainer(),
      items: items,
      totalItemsCount: totalItems,
      resizeMediaUrl: resizeMediaUrl,
      currentIdx: current.item.idx,
      actions: actions,
      styles: fixedStyles.desktopFullscreen
    };
    var style = {
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '100%'
    };
    return /*#__PURE__*/React.createElement("div", {
      style: style
    }, /*#__PURE__*/React.createElement(ProGallerySlider, props));
  };

  _proto.getProGalleryContainer = function getProGalleryContainer() {
    var currentWindow = this.props.currentWindow;
    return {
      width: currentWindow.size.width,
      height: currentWindow.size.height
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    var fullscreenStyle = this.props.styles.expandInfoPosition === Consts.expandInfoPositions.BOTTOM ? {
      overflowY: 'visible',
      overflowX: 'hidden'
    } : {};
    return /*#__PURE__*/React.createElement("div", {
      ref: function ref(_ref) {
        return _this2.props.setRef(_ref);
      },
      "data-hook": "fullscreen-view",
      id: "fullscreen-view",
      className: this.props.fullscreenClasses,
      style: fullscreenStyle,
      role: "dialog",
      "aria-label": "Gallery item, detailed view"
    }, this.getSlider(), this.getDesktopNavbar());
  };

  return DesktopFullscreen;
}(React.Component);

export default DesktopFullscreen;